import React, { useEffect, useMemo, useState } from "react";
import "./TabPay.scss";
import {
  Button,
  Checkbox,
  Col,
  Form,
  Input,
  InputNumber,
  Popconfirm,
  Row,
  Select,
  Space,
  Spin,
  Table,
  Typography,
  notification,
} from "antd";
import { InputFields, ListActionButton } from "components/common";
import { EyeSVG, PenSVG, RecycleSVG } from "assets";
import { columnsTabPay } from "./TabPayColumn.config";
import ModalTabPay from "./ModalTabPay/ModalTabPay";
import { payService } from "api";
import { useAppDispatch, useAppSelector } from "redux/hooks";
import {
  setCallApi,
  setDataPay,
  setId,
  setIdSecond,
  setListIdCommon,
  setTableThanhToan,
  setValueMG,
} from "redux/reducer/reduxCommon";
import Icon from "assets/icons";
import moment from "moment";
import { TabPayConfig } from "./TabPay.config";
import ModalPrint from "./ModalPrint/ModalPrint";
import { formatToCurrencyType } from "helper/common";
import Notification from "components/common/notification/notification";
import ModalEdit from "./ModalEdit/ModalEdit";
import TableInputAdd from "./TableInputAdd/TableInputAdd";
import { FIELD_TYPE, FORMAT_TIME } from "types/enums";
import ModalOptionPrint from "../Prepay/ModalOptionPrint/ModalOptionPrint";
import ModalPrintPPT from "../Prepay/ModalPrintPPT/ModalPrintPPT";
const { INPUT, SELECT, DATE, AUTO_COMPLETE } = FIELD_TYPE;

interface EditableCellProps extends React.HTMLAttributes<HTMLElement> {
  editing: boolean;
  dataIndex: string;
  title: any;
  inputType: "number" | "text";
  record: any;
  index: number;
  children: React.ReactNode;
}

const { Text } = Typography;

const TabPay = ({ dataPatient, type }) => {
  const listPayments = [
    { value: 0, label: "Tiền mặt" },
    { value: 1, label: "Chuyển khoản" },
    { value: 2, label: "Quẹt thẻ" },
  ];

  const columnTable: any = [
    {
      title: "STT",
      dataIndex: "stt",
      key: "stt",
      render: (text, record, index) => index + 1,
      width: "4%",
      fixed: "left",
      align: "center",
    },
    {
      title: "Hình thức thanh toán",
      dataIndex: "idHinhThucThanhToan",
      key: "idHinhThucThanhToan",
      width: "24%",
      // type: SELECT,
      // options: listPayments,
    },
    {
      title: "Số tiền GD",
      dataIndex: "soTienGiaoDich",
      key: "soTienGiaoDich",
      width: "24%",
      // type: INPUT,
    },
    {
      title: "Mã giao dịch",
      dataIndex: "maGiaoDich",
      key: "maGiaoDich",
      width: "24%",
      // type: INPUT,
    },
    // {
    //   title: "Số tiền trả lại",
    //   dataIndex: "soTienTraLai",
    //   key: "soTienTraLai",
    //   width: "24%",
    //   // type: INPUT,
    // },
    {
      title: "",
      dataIndex: "action",
      key: "action",
      width: "4%",
    },
  ];

  const [form] = Form.useForm();
  const [formTable] = Form.useForm();
  const [formTableInput] = Form.useForm();
  const [data, setData] = useState([]);
  const [dataTable, setDataTable] = useState<any>([
    // {
    //   key: "number",
    // }
  ]);
  const [dataPay, setDataPay] = useState([]);
  const [isShowModal, setIsShowModal] = useState(false);
  const [isShowModalPrint, setIsShowModalPrint] = useState(false);
  const [loadingTable, setLoadingTable] = useState(false);
  const [totalPage, setTotalPage] = useState();
  const [currentPage, setCurrentPage] = useState(1);
  const [apiCalled, setApiCalled] = useState(false);
  const disPath = useAppDispatch();
  const callApi = useAppSelector((state) => state.reduxCommon.callApi);
  const idData = useAppSelector((state) => state.reduxCommon.id);
  const [selectedRowKeys, setSelectedRowKeys] = useState<React.Key[]>([]);
  const [selectedRows, setSelectedRows] = useState([]);
  const tenThuNgan = useAppSelector((state) => state.reduxCommon.valueInput);
  const [minCurrency, setMinCurrency] = useState(0);
  const idBh = useAppSelector((state) => state.common.idReceiptPrint);
  const [listId, setListId] = useState([]);
  const [isShowModalEdit, setIsShowModalEdit] = useState(false);
  const [dataEdit, setDataEdit] = useState();
  const [valueTotal, setValueTotal] = useState<any>(0);
  const [maxBnPay, setMaxBnPay] = useState<any>();
  const [valueMienGiam, setValueMienGiam] = useState<any>(0);

  const [isShowModalPrintPPT, setIsShowModalPrintOption] = useState(false);
  const [dataPPT, setDataPPT] = useState([]);

  // const [checkBoxValue, setCheckBoxValue] = useState<any>();
  // const [checkBoxValueBH, setCheckBoxValueBH] = useState({});
  const [loading, setLoading] = useState(false);
  const activeTab = useAppSelector((state) => state.common.activeTab);
  // const listPayments = [
  //   { value: 0, label: "Tiền mặt" },
  //   { value: 1, label: "Chuyển khoản" },
  //   { value: 2, label: "Quẹt thẻ" },
  // ];

  useEffect(() => {
    disPath(setTableThanhToan([]));
    setValueMienGiam(0);
    setListId([]);
    disPath(setListIdCommon([]));
  }, [idData]);

  // const tachPhanTu = (dataInput) => {
  //   const newData = [];
  //   dataInput.forEach(item => {
  //       if (item.soLuong > 1) {
  //           for (let i = 0; i < item.soLuong; i++) {
  //               const newItem = { ...item, soLuong: 1 };
  //               newData.push(newItem);
  //           }
  //       } else {
  //           newData.push(item);
  //       }
  //   });
  //   return newData;
  // }

  useEffect(() => {
    getDataTable();
  }, [currentPage, idData, callApi, type]);

  // useMemo(() => {
  //   getDataTable();
  // }, [type]);

  const getDataTable = async () => {
    setLoading(true);
    setLoadingTable(true);
    try {
      const response = await payService
        .getListDetailPayById(idData, type)
        .then((res) => {
          // notification.success({ message: "Lấy dữ liệu thành công" });
          const newData = res.data.data.map((item) => ({
            ...item,
            key: item.id,
            id: item.id,
            idThanhToan: item.idThanhToan,
            idLanKham: item.idLanKham,
            content: item.tenChiDinh,
            ngayChiDinh: item.thoiGian,
            theBaoHiem: item.theBaoHiem,
            tinhTienTheoTheBaoHiem: item.tinhTienTheoTheBaoHiem,
            donGiaBenhVien: Math.abs(item.donGiaBenhVien),
            donGiaBaoHiem: Math.abs(item.donGiaBaoHiem),
            soLuong: item.soLuong,
            thanhTien: Math.abs(item.thanhTien),
            bhpay: Math.abs(item.baoHiemThanhToan),
            bnpay: Math.abs(item.benhNhanCungChiTra),
            bnpaid: Math.abs(item.benhNhanTuTra),
            status: item.trangThaiThanhToan,
            tenThuNgan: item.nhanVienThanhToan,
            thoiGianThanhToan: item.thoiGianThanhToan,
            soTienMienGiam: Math.abs(item.soTienMienGiam),
            lyDoMienGiam: item.lyDoMienGiam,
            thanhTienChuaMienGiam: Math.abs(item.thanhTienChuaMienGiam),
            theBenhNhan: item.theBenhNhan,
            tinhTienTheoTheBenhNhan: item.tinhTienTheoTheBenhNhan,
          }));

          setData(newData);
          const selectedRow = newData.filter((e) =>
            e.status === 0 || e.status === 2 ? e.key : null
          );
          setSelectedRows(selectedRow);
          const getKeySelectd = selectedRow.map((e) => e.key);
          setSelectedRowKeys(getKeySelectd);
          const selectedRowStatuses = selectedRow.filter(
            (row) => row.status == 0 || row.status == 2
          );

          setDataPay(selectedRowStatuses);
          setLoadingTable(false);
          setTotalPage(res.data.total);
        });
      setLoading(false);
    } catch (error) {
      setLoading(false);
      if (idData) {
        Notification(
          "error",
          "Đã có lỗi xảy ra khi lấy danh sách dịch vụ thanh toán"
        );
      }

      setLoadingTable(false);
    }
  };

  useEffect(() => {
    postListDetailPay();
  }, [dataPay, selectedRowKeys, valueMienGiam, callApi, activeTab]);

  useEffect(() => {
    setDataTable([
      {
        // key: "number",
        idHinhThucThanhToan: 0,
        soTienGiaoDich: 0,
        maGiaoDich: "",
      },
    ]);
  }, [activeTab]);

  const formatter = (value) => {
    // return `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    return `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  };

  const parser = (value) => {
    // return value.replace(/\$\s?|(,*)/g, "");
    return value.replace(/,/g, "");
  };

  useEffect(() => {
    let totalValue = 0;
    dataTable.map((item) => {
      totalValue += Number(item?.soTienGiaoDich ?? 0);
    });
    // for (let i = 0; i < dataTable.length; i++) {
    //   totalValue += dataTable[i].soTienGiaoDich;
    // }
    // formTableInput.setFieldValue("tongGiaoDich", totalValue);
    setValueTotal(totalValue);
  }, [dataTable]);

  columnTable.map((col) => {
    if (col.dataIndex == "idHinhThucThanhToan") {
      col.render = (value, record: any, index) => {
        return (
          <Select
            style={{ width: "100%" }}
            options={listPayments}
            value={value}
            onChange={(e, option: any) => {
              setDataTable((prevDataTable) => {
                return prevDataTable.map((prevItem, idx) =>
                  idx === index
                    ? {
                        ...prevItem,
                        idHinhThucThanhToan: option.value,
                      }
                    : prevItem
                );
              });
            }}
          ></Select>
        );
      };
    }

    if (col.dataIndex == "soTienGiaoDich") {
      col.render = (value, record: any, index) => {
        return (
          <InputNumber
            style={{ width: "100%" }}
            formatter={formatter}
            parser={parser}
            defaultValue={0}
            controls={false}
            // max={maxBnPay}
            required
            // placeholder="Nhập"
            value={value}
            onChange={(e) => {
              let valueTraLai = record.soTienTraLai;
              setDataTable((prevDataTable) => {
                return prevDataTable.map((prevItem, idx) =>
                  idx === index
                    ? {
                        ...prevItem,
                        soTienGiaoDich: e,
                      }
                    : prevItem
                );
              });
            }}
          ></InputNumber>
        );
      };
    }

    if (col.dataIndex == "maGiaoDich") {
      col.render = (value, record: any, index) => {
        return (
          <Input
            style={{ width: "100%" }}
            // placeholder="Nhập"
            value={value}
            onChange={(e) => {
              setDataTable((prevDataTable) => {
                return prevDataTable.map((prevItem, idx) =>
                  idx === index
                    ? {
                        ...prevItem,
                        maGiaoDich: e.target.value,
                      }
                    : prevItem
                );
              });
            }}
          ></Input>
        );
      };
    }

    // if (col.dataIndex == "soTienTraLai") {
    //   col.render = (value, record: any, index) => {
    //     return (
    //       <InputNumber
    //         style={{ width: "100%" }}
    //         formatter={formatter}
    //         parser={parser}
    //         // placeholder="Nhập"
    //         // defaultValue={0}
    //         value={value}
    //         onChange={(e) => {
    //           // let valueGiaoDich = record.soTienGiaoDich;
    //           setDataTable((prevDataTable) => {
    //             return prevDataTable.map((prevItem, idx) =>
    //               idx === index
    //                 ? {
    //                     ...prevItem,
    //                     soTienTraLai: e,
    //                   }
    //                 : prevItem
    //             );
    //           });
    //         }}
    //       ></InputNumber>
    //     );
    //   };
    // }
  });

  columnsTabPay.map((col) => {
    if (col.dataIndex == "action") {
      col.render = (value, record: any, index) => {
        return (
          <ListActionButton
            editFunction={() => handleEdit(record)}
          ></ListActionButton>
        );
      };
    }
    if (col.dataIndex == "theBaoHiem") {
      col.render = (value, record: any, index) => {
        if (value && record.status == 0) {
          if (record.tinhTienTheoTheBaoHiem) {
            return (
              <Checkbox
                key={record.idThanhToan}
                checked={true}
                onChange={(e) => handleCheckboxChangeBH(record.key)}
              ></Checkbox>
            );
          } else {
            return (
              <Checkbox
                key={record.idThanhToan}
                checked={false}
                onChange={(e) => handleCheckboxChangeBH(record.key)}
              ></Checkbox>
            );
          }
        }
        if (value && record.status == 2) {
          if (record.tinhTienTheoTheBaoHiem) {
            return (
              <Checkbox
                key={record.idThanhToan}
                checked={true}
                onChange={(e) => handleCheckboxChangeBH(record.key)}
              ></Checkbox>
            );
          } else {
            return (
              <Checkbox
                key={record.idThanhToan}
                checked={false}
                onChange={(e) => handleCheckboxChangeBH(record.key)}
              ></Checkbox>
            );
          }
        }
        if (value && record.status == 1) {
          if (record.tinhTienTheoTheBaoHiem) {
            return (
              <Checkbox
                key={record.idThanhToan}
                checked={true}
                disabled={true}
              ></Checkbox>
            );
          } else {
            return (
              <Checkbox
                key={record.idThanhToan}
                checked={false}
                disabled={true}
              ></Checkbox>
            );
          }
        } else {
          return <Checkbox disabled={true} checked={false}></Checkbox>;
        }
      };
    }
    if (col.dataIndex == "theBenhNhan") {
      col.render = (value, record: any, index) => {
        if (value && record.status == 0) {
          if (record.tinhTienTheoTheBenhNhan) {
            return (
              <Checkbox
                key={record.idThanhToan}
                checked={true}
                onChange={(e) => handleCheckboxChangeTBN(record.key)}
              ></Checkbox>
            );
          } else {
            return (
              <Checkbox
                key={record.idThanhToan}
                checked={false}
                onChange={(e) => handleCheckboxChangeTBN(record.key)}
              ></Checkbox>
            );
          }
        }
        if (value && record.status == 2) {
          if (record.tinhTienTheoTheBenhNhan) {
            return (
              <Checkbox
                key={record.idThanhToan}
                checked={true}
                onChange={(e) => handleCheckboxChangeTBN(record.key)}
              ></Checkbox>
            );
          } else {
            return (
              <Checkbox
                key={record.idThanhToan}
                checked={false}
                onChange={(e) => handleCheckboxChangeTBN(record.key)}
              ></Checkbox>
            );
          }
        }
        if (value && record.status == 1) {
          if (record.tinhTienTheoTheBenhNhan) {
            return (
              <Checkbox
                key={record.idThanhToan}
                checked={true}
                disabled={true}
              ></Checkbox>
            );
          } else {
            return (
              <Checkbox
                key={record.idThanhToan}
                checked={false}
                disabled={true}
              ></Checkbox>
            );
          }
        } else {
          return <Checkbox disabled={true} checked={false}></Checkbox>;
        }
      };
    }
  });

  const handleCheckboxChangeBH = (id) => {
    // setCheckBoxValueBH((prevStates) => {
    //   return {
    //     ...prevStates,
    //     [id]: !prevStates[id],
    //   };
    // });
    // setCheckBoxValueBH(e.target.checked)
    updateBhTicket(id);
  };

  const handleCheckboxChangeTBN = (id) => {
    // setCheckBoxValue((prevStates) => {
    //   return {
    //     ...prevStates,
    //     [id]: !prevStates[id],
    //   };
    // });
    // setCheckBoxValue(e.target.checked)
    updatePatientTicket(id);
  };

  // useEffect(() => {
  // }, [checkBoxValue]);

  const updateBhTicket = async (id) => {
    try {
      setLoading(true);
      setLoadingTable(true);
      const response = await payService.updateBHCard(id).then((res) => {
        Notification("success", "Cập nhật trạng thái thẻ bảo hiểm thành công");
      });
      setLoading(false);
      setLoadingTable(false);
      disPath(setCallApi());
    } catch (error) {
      setLoading(false);
      setLoadingTable(false);
      Notification("error", "Cập nhật trạng thái thẻ bảo hiểm thất bại");
    }
  };

  const updatePatientTicket = async (id) => {
    try {
      setLoading(true);
      setLoadingTable(true);
      const response = await payService.updatePatientCard(id).then((res) => {
        Notification("success", "Cập nhật trạng thái thẻ bệnh nhân thành công");
      });
      setLoading(false);
      setLoadingTable(false);
      disPath(setCallApi());
    } catch (error) {
      setLoading(false);
      setLoadingTable(false);
      Notification("error", "Cập nhật trạng thái thẻ bệnh nhân thất bại");
    }
  };

  useEffect(() => {
    sumColumn();
  }, [dataTable]);

  const handleEdit = (record) => {
    if (record.status == 1) {
      Notification("warning", "Vui lòng chọn dịch vụ chưa thanh toán");
      return;
    }
    setDataEdit(record);
    setIsShowModalEdit(true);
  };

  const sumColumn = () => {
    let sumCol1 = dataTable.reduce((accumulator, item) => {
      return isNaN(accumulator + item.soTienGiaoDich)
        ? null
        : accumulator + item.soTienGiaoDich;
    }, 0);
    let sumCol2 = dataTable.reduce((accumulator, item) => {
      return isNaN(accumulator + item.soTienTraLai)
        ? null
        : accumulator + item.soTienTraLai;
    }, 0);
    const result = sumCol1 - sumCol2;
    // formTableInput.setFieldValue("tongGiaoDich", result);
    // setValueTotal(result);
    return result;
  };

  const postListDetailPay = async () => {
    if (!dataPay || !dataPay.length) {
      form.resetFields();
      return;
    }
    const arrayData = dataPay.map((item) => item.key);
    const newData = {
      list_id: arrayData,
      id_lan_kham: idData,
      tien_mien_giam: valueMienGiam,
    };

    try {
      setLoading(true);
      const response = await payService
        .postListDetailPay(newData)
        .then((res) => {
          const newData = res.data;
          form.setFieldsValue(newData);
          setMaxBnPay(Math.abs(res.data.benhNhanPhaiTra));
          // form.setFieldValue("maGiaoDich", 0);
        });
      setLoading(false);
    } catch (error) {
      setLoading(false);
    }
  };

  const handlePaginationChange = (page) => {
    setCurrentPage(page);
  };

  const paginationConfig = {
    current: currentPage,
    total: totalPage,
    onChange: handlePaginationChange,
  };

  const handleOnSuccessPay = async () => {
    let isValid = true;
    dataTable.map((item) => {
      if (!item.soTienTraLai) {
        item.soTienTraLai = 0;
      }
      if (!item.maGiaoDich) {
        item.maGiaoDich = "";
      }
    });

    if (!dataPay || !dataPay.length) {
      Notification(
        "warning",
        "Dịch vụ đã được thanh toán hoặc chưa chọn dich vụ để thanh toán"
      );
      return;
    }
    const arrayData = dataPay.map((item) => item.key);
    setListId(arrayData);
    const newArrayTable = dataTable.map((item) => {
      const { key, ...newItem } = item;
      return newItem;
    });
    const dataSucces: any = {
      list_id: arrayData,
      tongTienMienGiam: parseInt(valueMienGiam, 10),
      type: 0,
    };
    if (tenThuNgan) {
      dataSucces.tenNhanVien = tenThuNgan;
    } else {
      dataSucces.tenNhanVien = localStorage.getItem("fullName");
    }
    // dataPay.map((item) => {
    dataSucces.thoiGianThanhToan = moment().format(FORMAT_TIME.dateTime);
    dataSucces.list_phuong_thuc = newArrayTable;
    // dataSucces.hinhThucThanhToan = form.getFieldValue("hinhThucThanhToan");
    // dataSucces.soTienGiaoDich = form.getFieldValue("soTienGiaoDich");
    // dataSucces.maGiaoDich = form.getFieldValue("maGiaoDich");
    // dataSucces.soTienTraLai = form.getFieldValue("soTienTraLai");
    // });

    newArrayTable.map((item) => {
      if (
        item.idHinhThucThanhToan == null ||
        item.idHinhThucThanhToan == undefined
      ) {
        Notification("warning", "Vui lòng chọn 1 hình thức thanh toán");
        isValid = false;
        return;
      }
      if (valueTotal < maxBnPay || valueTotal > maxBnPay) {
        Notification(
          "warning",
          "Vui lòng chọn nhập số tiền giao dịch bằng số tiền bệnh nhân phải trả"
        );
        isValid = false;
        return;
      }
      if (item.soTienGiaoDich == null || item.soTienGiaoDich == undefined) {
        // Notification("warning", "Vui lòng chọn nhập số tiền giao dịch");
        item.soTienGiaoDich = 0;
        isValid = true;
        return;
      }
    });
    if (!isValid) {
      return;
    }

    await submitSuccessPay(dataSucces);
    getDataTable();
    setSelectedRowKeys([]);
    setDataPay([]);
    disPath(setCallApi());
    disPath(setTableThanhToan(dataTable));
    form.resetFields();
    setDataTable([
      {
        // key: "number",
        idHinhThucThanhToan: 0,
        soTienGiaoDich: 0,
        maGiaoDich: "",
      },
    ]);
    // setCurrentTab(tabKeys.PAYCHILD.TAB_2);
  };

  const submitSuccessPay = async (data) => {
    setLoading(true);
    try {
      const response = await payService.getActionSuccessPay(data);
      Notification("success", "Thanh toán thành công");
      setLoading(false);
    } catch (error) {
      console.log("🚀 ~ submitSuccessPay ~ error:", error);
      setLoading(false);
      Notification("error", error.response.data);
    }
  };

  const handleOk = () => {
    setIsShowModal(false);
  };

  const handleCancel = () => {
    setIsShowModal(false);
    setApiCalled(false);
  };

  const handleOpen = () => {
    setIsShowModalPrint(false);
  };

  const handleCancelPrint = () => {
    setIsShowModalPrint(false);
  };

  const handleCancelEdit = () => {
    setIsShowModalEdit(false);
  };

  const handleOpenEdit = () => {
    setIsShowModalEdit(false);
  };

  const rowSelection = {
    selectedRowKeys,
    onChange: async (selectedRowKeys, selectedRows) => {
      setSelectedRowKeys(selectedRowKeys);

      setSelectedRows(selectedRows);
      const selectedRowPrint = selectedRows.filter((row) => row.status == 1);
      const newArr = selectedRowPrint.map((item) => item.id);
      setListId(newArr);
      disPath(setListIdCommon(newArr));
      const selectedRowStatuses = selectedRows.filter(
        (row) => row.status !== 1 && row.status !== 3
      );
      setDataPay(selectedRowStatuses);
    },
    getCheckboxProps: (record: any) => ({
      name: record.name,
    }),
  };

  const calculateSelectedRowsTotal = (selectedRows, dataIndex) => {
    const total = selectedRows.reduce((acc, current) => {
      return acc + parseFloat(current[dataIndex]);
    }, 0);

    return isNaN(total) ? "-" : formatToCurrencyType(total.toFixed(0));
  };

  const onFinishFail = (error) => {};

  // useEffect(() => {
  //   form.setFieldsValue({
  //     soTienGiaoDich: 0,
  //     soTienTraLai: 0,
  //     hinhThucThanhToan: "",
  //     maGiaoDich: 0,
  //   });
  // }, [idData]);

  useEffect(() => {
    form.resetFields();
  }, [idData]);

  const handleOnPrint = () => {
    if (!listId.length) {
      Notification("warning", "Vui lòng chọn dịch vụ đã thanh toán");
      return;
    }

    setIsShowModalPrint(true);
  };

  const onChangeInput = (value) => {
    if (value == null || value == undefined) {
      setValueMienGiam(0);
      disPath(setValueMG(0));
    } else {
      setValueMienGiam(value);
      disPath(setValueMG(value));
    }
  };

  useEffect(() => {
    disPath(setValueMG(form.getFieldValue("tongMienGiamThanhToan")));
  }, [valueMienGiam, form]);

  // in phiếu phụ thu
  const handleOpenPPT = () => {
    setIsShowModalPrintOption(true);
  };
  const handleCancelPrintPPT = () => {
    setIsShowModalPrintOption(false);
  };

  const handleOnPrintPhuThu = () => {
    if (dataPay.length === 0) {
      Notification("warning", "Chưa chọn dịch vụ");
    } else {
      handleOpenPPT();
      const res = selectedRows.filter(
        (el) => (el.status === 2 || el.status === 1) && el.idLoaiDichVu === 13
      );
      setDataPPT(res);
    }
  };
  return (
    <Spin spinning={loading}>
      <div className="tab-pay-child-container">
        <Space direction="vertical" size={"middle"} style={{ width: "100%" }}>
          <Form
            form={form}
            onFinishFailed={onFinishFail}
            // onFinish={handleOnSuccessPay}
            initialValues={{ remember: true }}
            autoComplete="off"
          >
            <Row gutter={[16, 16]}>
              <InputFields data={TabPayConfig(onChangeInput, minCurrency)} />
            </Row>
          </Form>
          {/* <Form> */}
          <Row
            justify={"space-between"}
            gutter={[16, 16]}
            style={{ alignItems: "center" }}
          >
            <Col>
              <Typography.Text strong>Hình thức thanh toán</Typography.Text>
            </Col>
            <Col>
              <Space>
                <Typography.Text strong>Tổng giao dịch</Typography.Text>
                {/* <Form.Item name="tongGiaoDich"> */}
                <InputNumber
                  formatter={formatter}
                  parser={parser}
                  style={{ color: "black", width: "200px" }}
                  disabled
                  value={valueTotal}
                ></InputNumber>
                {/* </Form.Item> */}
              </Space>
            </Col>
          </Row>
          <Row gutter={[16, 16]} style={{ marginTop: "16px" }}>
            <Col span={24}>
              <Form form={formTableInput}>
                <TableInputAdd
                  data={dataTable}
                  column={columnTable}
                  setData={setDataTable}
                  pagination={false}
                ></TableInputAdd>
              </Form>
            </Col>
          </Row>
          {/* </Form> */}
          <Row justify={"end"} style={{ marginTop: "16px" }}>
            <Space>
              <Button
                type="primary"
                className="btn-sub"
                icon={<Icon.printer />}
                onClick={handleOnPrintPhuThu}
              >
                In phiếu phụ thu
              </Button>
              <Button
                type="primary"
                className="btn-sub"
                icon={<Icon.printer />}
                onClick={handleOnPrint}
              >
                In phiếu thu lẻ
              </Button>
              <Button type="primary" onClick={handleOnSuccessPay}>
                Hoàn thành thanh toán
              </Button>
            </Space>
          </Row>
          <Row gutter={[16, 16]}>
            <Col span={24}>
              <Form form={formTable} component={false}>
                <Table
                  bordered
                  dataSource={data}
                  scroll={{ x: 2300 }}
                  columns={columnsTabPay}
                  rowClassName="editable-row"
                  pagination={false}
                  loading={loadingTable}
                  rowSelection={{
                    ...rowSelection,
                  }}
                  summary={(data) => {
                    const columns = columnsTabPay;

                    return (
                      <Table.Summary.Row>
                        {columns.map((col, index) => {
                          if (col.key === "content") {
                            return (
                              <>
                                <Table.Summary.Cell
                                  key={index}
                                  index={index}
                                ></Table.Summary.Cell>
                                <Table.Summary.Cell key={index} index={index}>
                                  <Typography.Text strong>
                                    Tổng cộng:
                                  </Typography.Text>
                                </Table.Summary.Cell>
                              </>
                            );
                          }
                          if (
                            col.key === "bnpay" ||
                            col.key === "bnpaid" ||
                            col.key === "bhpay" ||
                            col.key === "thanhTien"
                          ) {
                            return (
                              <Table.Summary.Cell
                                key={index}
                                index={index}
                                align="right"
                              >
                                <Typography.Text strong>
                                  {calculateSelectedRowsTotal(
                                    selectedRows,
                                    col.dataIndex
                                  )}
                                </Typography.Text>
                              </Table.Summary.Cell>
                            );
                          }
                          return (
                            <Table.Summary.Cell index={index} key={index} />
                          );
                        })}
                      </Table.Summary.Row>
                    );
                  }}
                />
              </Form>
            </Col>
          </Row>
        </Space>
        <ModalTabPay
          isShowModal={isShowModal}
          handleOk={handleOk}
          handleCancel={handleCancel}
          apiCalled={apiCalled}
        />
        <ModalPrint
          isShowModal={isShowModalPrint}
          handleOk={handleOpen}
          handleCancel={handleCancelPrint}
          listId={listId}
          dataTable={dataTable}
        />
        <ModalEdit
          isShowModal={isShowModalEdit}
          handleOk={handleOpenEdit}
          handleCancel={handleCancelEdit}
          data={dataEdit}
        ></ModalEdit>
        <ModalPrintPPT
          isShowModal={isShowModalPrintPPT}
          handleOk={handleOpenPPT}
          handleCancel={handleCancelPrintPPT}
          listId={listId}
          dataPPT={dataPPT}
          value={"phiếu phụ thu"}
          callApi={false}
          dataPatient={dataPatient}
        />
      </div>
    </Spin>
  );
};

export default TabPay;
